import { render, staticRenderFns } from "./branch_block_date.vue?vue&type=template&id=21050dfe&"
import script from "./branch_block_date.vue?vue&type=script&lang=js&"
export * from "./branch_block_date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports